<template>
  <settings :settingTabs="userSettingTabs" :initialTab="initialTab" key="user">
    {{ this.$t('userSettings') }}
  </settings>
</template>

<script>
import Settings from '@/components/Settings'
import Constants from '@/components/Constants'

export default {
  mixins: [Constants],
  components: {
    Settings,
  },
  props: {
    initialTab: Object,
  },
  data() {
    return {
      userSettingTabs: this.getUserSettingsTabs(),
    }
  },
}
</script>
